<template>
  <div class="creators-area-banner">
    <f7-block class="no-margin-vertical">
      <container class="creators-area-banner-container">
        <div class="creators-area-banner-title">
          {{ $t('creators_area') }}
        </div>

        <div class="creators-area-balance">
          {{ `${$t('balance')}: ${balance}$` }}
        </div>

        <f7-link class="creators-area-request" @click="handlePayout">
          {{ $t('payout_request') }}
        </f7-link>
      </container>
    </f7-block>
  </div>
</template>

<script>
import apiRequest from '../js/helpers/apiRequest.js';
import notify from '../js/helpers/notify.js';

import Container from './Container.vue';

export default {
  name: 'CreatorsAreaBanner',

  components: {
    Container,
  },

  computed: {
    balance() {
      return this.$store.state.user.userCoursesBalance;
    },
  },

  methods: {
    async handlePayout() {
      try {
        this.$f7.progressbar.show();
        const res = await apiRequest('my/courses/withdraw', 'POST', null, true);
        this.$f7.progressbar.hide();

        if (res.error) {
          notify({ text: res.error });
        } else {
          notify({ text: res.success });
        }
      } catch (error) {
        this.$f7.progressbar.hide();
        console.log('handlePayout:', error);
        notify({ text: this.$t(`notify.something_went_wrong`) });
      }
    },
  },
};
</script>

<style lang="less">
.creators-area-banner {
  padding: 10px 0;
  color: #ffffff;
  font-size: 16px;
  background-color: var(--f7-color-purple);
}

.creators-area-banner-title {
  font-weight: 600;

  @media (max-width: 575.99px) {
    display: none;
  }
}

.creators-area-banner-container {
  display: flex;
  align-items: center;
  height: 100%;
}

.creators-area-balance {
  font-weight: 600;
  margin-left: 130px;

  @media (max-width: 767.98px) {
    margin-left: 30px;
  }

  @media (max-width: 575.99px) {
    margin-left: 0;
  }
}

.creators-area-request {
  font-weight: 600;
  color: #ffffff;
  text-decoration: underline;
  margin-left: 30px;
}
</style>
